<template>
  <div id="app-outer">
    <div id="app-scale-container" :style="scaleStyle" ref="scaleContainer">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      scale: 1
    };
  },
  computed: {
    scaleStyle() {
      return {
        zoom: this.scale,
        width: '2699px',
        margin: '0 auto'
      };
    }
  },
  methods: {
    updateScale() {
      this.$nextTick(() => {
        const designWidth = 2699;
        const windowWidth = window.innerWidth;
        // 宽度占浏览器90%，等比缩放，水平居中
        this.scale = (windowWidth * 0.9) / designWidth;
      });
    }
  },
  mounted() {
    this.updateScale();
    window.addEventListener('resize', this.updateScale);
    this.$watch('$route', () => {
      this.$nextTick(this.updateScale);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale);
  }
};
</script>

<style lang="css" src="./assets/common.css">
</style>
<style>
html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100vw;
}
#app {
  margin: 0;
  padding: 0;
  width: 100vw;
}
#app-outer {
  width: 100vw;
  overflow-x: auto;
  overflow-y: auto;
}
#app-scale-container {
  position: relative;
}
</style>
